// Route-contextual article suggestions for the Help drawer (the reference's
// "Suggestions" section): the drawer shows the three articles most relevant
// to where the user currently is, falling back to the getting-started trio.

const ROUTE_SUGGESTIONS: Array<{ match: RegExp; slugs: string[] }> = [
  { match: /^\/(money|invoices)/, slugs: ['how-invoices-work', 'getting-paid', 'sales-tax'] },
  {
    match: /^\/(messages|conversations|aria)/,
    slugs: ['how-the-assistant-texts', 'jump-into-a-conversation', 'customer-memory'],
  },
  { match: /^\/queue/, slugs: ['your-first-booking', 'how-the-assistant-texts', 'customer-memory'] },
  { match: /^\/customers/, slugs: ['customer-memory', 'jump-into-a-conversation', 'your-first-booking'] },
  { match: /^\/settings\/(billing|payments)/, slugs: ['plans-and-pricing', 'usage-and-allowances', 'getting-paid'] },
  { match: /^\/settings/, slugs: ['notifications', 'team-members', 'security'] },
  { match: /^\/upgrade/, slugs: ['plans-and-pricing', 'usage-and-allowances', 'upgrade-downgrade'] },
  { match: /^\/reminders/, slugs: ['your-first-booking', 'how-the-assistant-texts', 'notifications'] },
]

const DEFAULT_SUGGESTIONS = ['welcome-to-ten-four', 'how-the-assistant-texts', 'your-first-booking']

/** "Getting started" fixed section under the suggestions (reference design). */
export const GETTING_STARTED_SLUGS = ['set-up-your-account', 'your-first-booking']

export function suggestionsForRoute(pathname: string): string[] {
  const hit = ROUTE_SUGGESTIONS.find((r) => r.match.test(pathname))
  return hit?.slugs ?? DEFAULT_SUGGESTIONS
}
